"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardPhotoHeaderMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _spaceMixin = require("../spaceMixin");
/** @class PropertyCardPhotoHeaderMixin */
/** @method */
/**
 * Using `height: 0` and no vertical padding to allow as much of the photo to be clickable as
 * possible (CDS-1777)
 */
var PropertyCardPhotoHeaderMixin = function PropertyCardPhotoHeaderMixin(props) {
  return (0, _styledToken.default)({
    gap: 'PropertyCard.photo.header.gap',
    marginTop: 'PropertyCard.photo.header.marginTop',
    paddingX: 'PropertyCard.photo.header.padding.X',
    paddingY: 'PropertyCard.photo.header.padding.Y'
  }, function (_ref) {
    var gap = _ref.gap,
      marginTop = _ref.marginTop,
      paddingX = _ref.paddingX,
      _ref$paddingY = _ref.paddingY,
      paddingY = _ref$paddingY === void 0 ? 0 : _ref$paddingY;
    return (0, _styledComponents.css)(["grid-area:photo-top;height:0;margin-top:", ";padding:", ";z-index:1;display:grid;grid-auto-flow:column;grid-gap:", ";justify-content:space-between;"], marginTop ? marginTop + "px" : (0, _spaceMixin.spaceMixin)('xs')(props), paddingX && paddingY ? paddingY + "px " + paddingX + "px" : "0 " + (0, _spaceMixin.spaceMixin)('xs')(props), gap ? gap + "px" : (0, _spaceMixin.spaceMixin)('sm')(props));
  })(props);
};
exports.PropertyCardPhotoHeaderMixin = PropertyCardPhotoHeaderMixin;